import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ModalPicturePage } from 'src/app/components/modal-picture/modal-picture.page';
import { Experience } from 'src/app/models/ToursModels/experience';
import { reviewExperience } from 'src/app/models/ToursModels/review';
import { ReviewService } from 'src/app/services/review.service';

@Component({
  selector: 'app-experience-review-list',
  templateUrl: './experience-review-list.page.html',
  styleUrls: ['./experience-review-list.page.scss'],
})
export class ExperienceReviewListPage implements OnInit {
  @Input("experience") experience?: Experience;
  reviews: reviewExperience[] = [];
  votesByStars: { stars: number; votes: number }[] = [];
  averageRating = '';

  constructor(
    private reviewsService: ReviewService,
    private modalCtrl: ModalController,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.reviewsService
      .getReviewsIdExperience(this.experience?._id)
      .subscribe((data) => {
        this.reviews = data;
        this.updateVotesByStars();
        this.averageRating = this.getAverageRating();
        this.reviewsService.reviewsDataShared({
          averageRating: this.averageRating,
          numCalifications: this.reviews.length,
        });
      });
  }

  getProgress(stars: number): number {
    const set = this.votesByStars.find((item) => item.stars === stars);
    return set ? set.votes / this.getTotalVotes() : 0;
  }

  getTotalVotes(): number {
    return this.votesByStars.reduce((total, set) => total + set.votes, 0);
  }

  getStarRating(rating: number): string {
    const stars = '<ion-icon name="star"></ion-icon>'.repeat(rating);
    return (
      stars + '<ion-icon name="star-outline"></ion-icon>'.repeat(5 - rating)
    );
  }

  getStarRatingArray(rating: number): boolean[] {
    return Array.from({ length: 5 }, (_, index) => index < rating);
  }

  formatComment(comment: string): string {
    if (!comment) {
      return '';
    }
    return comment.charAt(0).toUpperCase() + comment.slice(1);
  }

  async openModalPicture(photo: string) {
    const modal = await this.modalCtrl.create({
      component: ModalPicturePage,
      componentProps: {
        photo,
      },
      cssClass: 'transparent-modal',
    });
    return await modal.present();
  }

  updateVotesByStars() {
    const votesCount: { [key: number]: number } = {};
    this.reviews.forEach((review) => {
      const stars = review.rating;

      if (stars in votesCount) {
        votesCount[stars]++;
      } else {
        votesCount[stars] = 1;
      }
    });
    this.votesByStars = Object.keys(votesCount)
      .map((stars) => ({
        stars: parseInt(stars),
        votes: votesCount[parseInt(stars)],
      }))
      .sort((a, b) => b.stars - a.stars);
  }

  getAverageRating(): string {
    const totalStars = this.votesByStars.reduce(
      (acc, set) => acc + set.stars * set.votes,
      0
    );
    const totalVotes = this.getTotalVotes();
    const averageRating = totalVotes > 0 ? totalStars / totalVotes : 0;
    const formattedAverage = averageRating.toFixed(1);
    return formattedAverage;
  }
}
